/* MAD BLOOM: animaciones del tema (barrido entre páginas, marquees, scroll horizontal, revelados, cursor) */
(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const design = !!(window.Shopify && Shopify.designMode);
  root.classList.add('mb-anim');

  /* Barrido horizontal entre páginas */
  const curtain = document.querySelector('[data-mb-curtain]');
  const leave = () => {
    try { sessionStorage.removeItem('mb-wipe'); } catch (e) {}
    if (!curtain || !root.classList.contains('mb-wipe')) { root.classList.remove('mb-wipe'); return; }
    curtain.classList.add('is-leaving');
    setTimeout(() => { root.classList.remove('mb-wipe'); curtain.classList.remove('is-leaving'); }, 900);
  };
  requestAnimationFrame(() => setTimeout(leave, 60));
  addEventListener('pageshow', (e) => {
    if (e.persisted && curtain) { curtain.classList.remove('is-entering', 'is-leaving'); root.classList.remove('mb-wipe'); }
  });
  if (curtain && !design && !reduce) {
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      const a = e.target.closest('a[href]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.closest('[data-mb-no-wipe]')) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && (url.hash || url.search === location.search)) return;
      if (/^\/(account|checkout|cart\/(add|change|clear))/.test(url.pathname) || url.pathname.includes('/checkouts/')) return;
      e.preventDefault();
      curtain.classList.add('is-entering');
      try { sessionStorage.setItem('mb-wipe', '1'); } catch (err) {}
      setTimeout(() => { location.href = url.href; }, 650);
    });
  }

  /* Cartel "muy pronto" de casa: aparece al entrar, se cierra para seguir mirando */
  const wlpop = document.querySelector('[data-mb-wlpop]');
  if (wlpop && !design) {
    const tab = document.querySelector('[data-mb-wlpop-open]');
    let closed = false;
    try { closed = sessionStorage.getItem('mb-wl-closed') === '1'; } catch (err) {}
    const posted = /customer_posted=true/.test(location.search);
    const open = () => { wlpop.hidden = false; if (tab) tab.hidden = true; };
    const close = () => {
      wlpop.hidden = true; if (tab) tab.hidden = false;
      try { sessionStorage.setItem('mb-wl-closed', '1'); } catch (err) {}
    };
    wlpop.addEventListener('click', (e) => { if (e.target.closest('[data-mb-wlpop-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !wlpop.hidden) close(); });
    if (tab) tab.addEventListener('click', open);
    if (posted || !closed) setTimeout(open, posted ? 0 : 700); else if (tab) tab.hidden = false;
  }

  /* Flores y pegatinas giran solo mientras haces scroll */
  if (!reduce) {
    let rotTick = false;
    const setRot = () => { document.documentElement.style.setProperty('--mb-rot', (scrollY * 0.25).toFixed(1) + 'deg'); rotTick = false; };
    addEventListener('scroll', () => { if (!rotTick) { rotTick = true; requestAnimationFrame(setRot); } }, { passive: true });
    setRot();
  }

  /* Cabecera que se esconde al bajar + menú móvil */
  let menuOpen = false;
  let lastY = scrollY;
  addEventListener('scroll', () => {
    const header = document.querySelector('[data-mb-header]');
    const y = scrollY;
    if (header) header.classList.toggle('is-hidden', y > lastY && y > 200 && !menuOpen);
    lastY = y;
  }, { passive: true });
  document.addEventListener('click', (e) => {
    const burger = e.target.closest('[data-mb-burger]');
    const menu = document.querySelector('[data-mb-menu]');
    if (!menu) return;
    if (burger) {
      menuOpen = !menuOpen;
    } else if (menuOpen && e.target.closest('[data-mb-menu] a')) {
      menuOpen = false;
    } else return;
    document.querySelectorAll('[data-mb-burger]').forEach((b) => b.setAttribute('aria-expanded', menuOpen));
    menu.hidden = !menuOpen;
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  });
  addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !menuOpen) return;
    document.querySelector('[data-mb-burger]')?.click();
  });

  /* Estado que se recalcula cuando el editor recarga una sección */
  let marquees = [], hs = [], grow = [], para = [];
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -12% 0px' });
  const cio = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (!en.isIntersecting) return;
    const el = en.target, to = parseFloat(el.dataset.count), t0 = performance.now();
    const step = (t) => { const k = Math.min((t - t0) / 1400, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
    reduce ? (el.textContent = to) : requestAnimationFrame(step);
    cio.unobserve(el);
  }), { threshold: .6 });

  /* Cifras con texto ("5-10", "0 €"): cada número del texto cuenta desde 0 */
  const uio = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (!en.isIntersecting) return;
    const el = en.target, src = el.dataset.countupSrc, t0 = performance.now();
    uio.unobserve(el);
    if (reduce || !/\d/.test(src)) { el.textContent = src; return; }
    const step = (t) => {
      const k = Math.min((t - t0) / 1600, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = src.replace(/\d{1,3}(?:\.\d{3})+|\d+/g, (n) => Math.round(parseInt(n.replace(/\./g, ''), 10) * e).toLocaleString('es-ES', { useGrouping: n.includes('.') ? 'always' : false }));
      if (k < 1) requestAnimationFrame(step); else el.textContent = src;
    };
    requestAnimationFrame(step);
  }), { threshold: .5 });

  const sizeH = () => hs.forEach((sec) => {
    const dist = sec._track.scrollWidth - innerWidth;
    sec.style.height = `${Math.max(dist, 0) + innerHeight}px`;
    sec._dist = dist;
  });

  const init = (scope = document) => {
    /* Titulares por líneas: cada <br> separa una línea que sube */
    scope.querySelectorAll('[data-split]:not([data-split-done])').forEach((el) => {
      const lines = el.innerHTML.split(/<br\s*\/?>/i);
      el.innerHTML = lines.map((l) => `<span class="mb-split-line"><span>${l.trim()}</span></span>`).join('');
      el.setAttribute('data-split-done', '');
    });
    scope.querySelectorAll('[data-wipe],[data-rise],[data-split]').forEach((el) => {
      if (design) el.classList.add('in'); else io.observe(el);
    });
    scope.querySelectorAll('[data-count]').forEach((el) => cio.observe(el));
    scope.querySelectorAll('[data-countup]').forEach((el) => {
      if (design) return;
      if (el.dataset.countupSrc == null) el.dataset.countupSrc = el.textContent.trim();
      uio.observe(el);
    });

    marquees = [...document.querySelectorAll('[data-marquee]')].map((el) => (
      el._mb || (el._mb = { el, track: el.querySelector('.mb-marquee__track'), x: 0, dir: el.dataset.reverse === '1' || el.dataset.reverse === 'true' ? 1 : -1 })
    )).filter((m) => m.track);

    hs = [...document.querySelectorAll('[data-hscroll]')];
    hs.forEach((sec) => { sec._track = sec.querySelector('[data-hscroll-track]'); });
    hs = hs.filter((s) => s._track);
    if (reduce) hs.forEach((s) => s.classList.add('no-pin')); else sizeH();

    grow = [...document.querySelectorAll('[data-grow]')];
    para = [...document.querySelectorAll('[data-speed]')];
  };

  init();
  if (!reduce) { addEventListener('resize', sizeH); addEventListener('load', sizeH); }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', () => setTimeout(() => init(), 0));

  /* Marquees: avanzan solos y cambian de sentido con el scroll */
  let scrollDir = 1, boost = 0, prevY = scrollY;
  addEventListener('scroll', () => {
    const d = scrollY - prevY; prevY = scrollY;
    if (d) scrollDir = d > 0 ? 1 : -1;
    boost = Math.min(Math.abs(d) * 0.4, 18);
  }, { passive: true });

  const tick = () => {
    marquees.forEach((m) => {
      if (!m.el.isConnected || !m.track.firstElementChild) return;
      const w = m.track.firstElementChild.offsetWidth;
      if (!reduce) m.x += (1 + boost) * m.dir * scrollDir;
      if (m.x <= -w) m.x += w; if (m.x > 0) m.x -= w;
      m.track.style.transform = `translate3d(${m.x}px,0,0)`;
    });
    boost *= 0.92;
    if (!reduce) {
      hs.forEach((sec) => {
        if (!sec.isConnected) return;
        const r = sec.getBoundingClientRect();
        const p = Math.min(Math.max(-r.top / (sec.offsetHeight - innerHeight || 1), 0), 1);
        sec._track.style.transform = `translate3d(${-p * Math.max(sec._dist || 0, 0)}px,0,0)`;
        sec.style.setProperty('--p', p.toFixed(3));
      });
      grow.forEach((el) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--g', Math.min(Math.max((innerHeight - r.top) / (innerHeight * .85), 0), 1).toFixed(3));
      });
      para.forEach((el) => {
        const r = el.getBoundingClientRect();
        const c = r.top + r.height / 2 - innerHeight / 2;
        el.style.transform = `translate3d(0,${c * parseFloat(el.dataset.speed)}px,0)`;
      });
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);

  /* Cursor */
  const cursor = document.querySelector('[data-mb-cursor]');
  if (fine && cursor && !design) {
    let cx = innerWidth / 2, cy = innerHeight / 2, tx = cx, ty = cy;
    cursor.classList.add('is-ready');
    root.classList.add('mb-has-cursor');
    addEventListener('mousemove', (e) => { tx = e.clientX; ty = e.clientY; });
    const label = cursor.querySelector('span');
    document.addEventListener('mouseover', (e) => {
      const lab = e.target.closest('[data-cursor-label]');
      const link = e.target.closest('a,button,summary,label,select,input[type="submit"]');
      cursor.classList.toggle('is-label', !!lab);
      cursor.classList.toggle('is-link', !lab && !!link);
      label.textContent = lab ? lab.dataset.cursorLabel : '';
    });
    const move = () => { cx += (tx - cx) * 0.2; cy += (ty - cy) * 0.2; cursor.style.transform = `translate3d(${cx}px,${cy}px,0)`; requestAnimationFrame(move); };
    move();
  }
})();
